import React from "react";

import clsx from "clsx";

import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";

import { BreakdownSelector } from "../../shared";
import { type TopLevelBreakdown } from "../../types";

interface Props {
  placeholder?: string;
  breakdownConfigs: CategoricalBreakdownConfig[];
  onChange(value: TopLevelBreakdown): void;
}

export const BreakdownButtonSelect = ({
  placeholder,
  breakdownConfigs,
  onChange,
}: Props) => (
  <div
    className={clsx(
      "text-sm border hover:border-cosmic rounded h-8",
      "flex items-stretch bg-white",
    )}
  >
    <BreakdownSelector
      mode="breakdowns"
      text={placeholder || "Select..."}
      breakdownConfigs={breakdownConfigs}
      selectedBreakdowns={[]}
      buttonClassName="max-w-[106px] h-full px-3 flex items-center"
      buttonActiveClassName="max-w-[106px] h-full px-3 flex items-center"
      butttonTextClassName="text-gray"
      butttonActiveTextClassName="text-interstellar"
      onSelectionChange={(values) => onChange(values[0])}
    />
  </div>
);
